import { FormEvent, useRef, useState, useMemo, useEffect } from 'react';

import { AnimatePresence, motion } from "framer-motion";

import * as S from './styles';

import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { useTranslation } from 'react-i18next';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { RootStateCarteira } from '../../../../../store/carteiraReducer';
import { CalcularImposto, DepositoCredito, DepositoDebito, DepositoPix, GetMeioPagamento, ResetPix } from '../../../../../store/deposito/actions/depositoAction';
import DepositoContainer from '../../../../../containers/deposito/depositoContainer';
import assets from 'base/src/assets/assets';
import { DepositoPixRequest } from '../../../../../types/deposito/depostioPixRequest';
import { FormToObject } from 'domain/utils/FormUtils';
import { toast } from 'react-toastify';
import { Forms } from 'base/src/components/Form';
import { Button } from 'base/src/components/Button';
import { CarteiraUsuarioResponse } from 'domain/types/_carteira/carteiraBase/carteiraUsuarioResponse';
import { useTheme } from 'base/src/utils/context/themeContext';
import { ModalClose } from 'base/src/components/Modal';
import { useNavigate } from "react-router-dom";

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    CalcularImposto: state.DepositoReducer.CalcularImposto,
    impostos: state.DepositoReducer.CalcularImposto,
    meioPagamentos: state.DepositoReducer.GetMeioPagamento,
    PixResponse: state.DepositoReducer.DepositoPix,
    PagamentoPix: state.DepositoReducer.PagamentoPix,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    BoletoGerado: state.DepositoReducer.DepositoBoleto,
  }),
  { DepositoPix, DepositoDebito, DepositoCredito, CalcularImposto, GetMeioPagamento, ResetPix }
);

export interface PagamentoPixProps extends PropsFromRedux<typeof connector> {
  valorDeposito: number;
  valorTotal: number;
  meioPagamento: string | null;
  CarteiraUsuario: CarteiraUsuarioResponse[];
  _container: DepositoContainer;
}


function PagamentoPix(props: PagamentoPixProps) {
  const depositoContainer = props._container;
  const theme = useTheme();
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const initialState = {} as DepositoPixRequest
  const [request] = useState<DepositoPixRequest>(initialState as DepositoPixRequest)

  const { t } = useTranslation();

  const formRef = useRef<HTMLFormElement>(null);


  useEffect(() => {
    props.ResetPix();
    setStep(1);
  }, []);

  useEffect(() => {
    if (props.PagamentoPix == null) { setStep(1); return }
    setStep(3);
  }, [props.PagamentoPix]);
  // Convert QR Code to proper base64 data URL
  const qrCodeSrc = useMemo(() => {
    if (!props.PixResponse?.QrCode) return '';

    const qrCode = props.PixResponse.QrCode;

    // If it's already a data URL, return as is
    if (qrCode.startsWith('data:')) {
      return qrCode;
    }

    // If it's a regular URL, return as is
    if (qrCode.startsWith('http')) {
      return qrCode;
    }
    // If it's base64 without data URL prefix, add it
    return `data:image/png;base64,${qrCode}`;

  }, [props.PixResponse?.QrCode]);

  function openModal() {
    setStep(2);
  }

  function handleStep(value: number) {
    return () => setStep(value);
  }

  function handleFechar() {
     navigate('/');
  }


  function handleForm(event: FormEvent<HTMLFormElement>) {
    const obj: DepositoPixRequest = FormToObject(new FormData(event.currentTarget), request)

    // toast(t("" + props.valorTotal), {type:"info"})
    //     toast(t("" + props.valorDeposito), {type:"info"})
    obj.Valor = props.valorDeposito;
    obj.CarteiraID = props.CarteiraUsuario[0].CarteiraID;

    if ((obj.Valor && obj.Valor != 0)) {
      depositoContainer.DepositoPix(obj, openModal);

    } else {
      toast(t("asdasdasdasd"), { type: "info" })
    }
    event.preventDefault()
  }

  function StepOne() {
    return (
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ duration: 0.3 }}
      >
        <Forms formRef={formRef} handleForm={handleForm} >
          <S.Container>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
              <img src={assets.logo_pix} alt="" style={{ width: 250 }} />
              <S.TitleContainer>
                <S.Column>
                  <S.Title>Depósito via {props.meioPagamento} no valor de {formatToBRL(props.valorTotal)}</S.Title>
                  {/* <S.Subtitle>Informe seus dados para confiarmar o pagamento</S.Subtitle> */}
                </S.Column>
              </S.TitleContainer>
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <MaskedInput form name='UsuarioNome' placeholder='Nome Completo' />
            <MaskedInput mask={maskLogic} form name='CPF' placeholder='CPF ou CNPJ' />
          </div> */}

            <S.Column>
              <S.Subtitle>Importante:</S.Subtitle>
              <S.Observacao>O prazo de confirmação do pagamento leva em média 10 segundos e depende da instituição financeira, portanto o tempo para processamento pode ser estendido.</S.Observacao>
            </S.Column>
            <div style={{ display: 'flex', gap: 10 }}>
              <Button type='submit' full size='md'>Continuar</Button>
            </div>
          </S.Container>
        </Forms>
      </motion.div>
    )
  }

  function copyToClipboard() {
    if (props.PixResponse?.PixCopiaCola) {
      navigator.clipboard.writeText(props.PixResponse.PixCopiaCola)
        .then(() => {
          toast("Código copiado!", { type: "info" })
        })
    }
  }

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars, no-unused-vars
  function StepTwo(_props: { handleBack: () => void }) {
    return (
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ duration: 0.3 }}
      >

        <S.SetpTwoContainer >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
            <img src={assets.logo_pix} alt="" style={{ width: '35vh' }} />
          </div>

          <img src={qrCodeSrc} style={{ width: '25vh' }} alt="QR Code PIX" />

          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 10 }}>
            <span style={{ fontWeight: 700, fontSize: 16 }}>Escaneie o código com seu celular</span>
            <span>Abra o app do seu banco no celular, escolha Pix e aponte a câmera pra o código</span>
          </div>

          <S.Row>
            <S.TextContainer>
              <S.SubtitleContainer>{props.PixResponse?.PixCopiaCola}</S.SubtitleContainer>
            </S.TextContainer>
          </S.Row>

          <div style={{}}>
            <Button size='md' onClick={copyToClipboard}>Copiar código</Button>
          </div>

          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 700 }}>Valor da transferência</span>
            <span>{formatToBRL(props.valorTotal)}</span>
          </div>

        </S.SetpTwoContainer>
      </motion.div >
    )
  }

  function StepTree() {
    return (
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ duration: 0.3 }}
      >

        <S.SetpTwoContainer >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
            <img src={assets.logo_pix} alt="" style={{ width: '35vh' }} />
          </div>

          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img src={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAY8AAAGPAQAAAACM4WFKAAAE+ElEQVR4nO2cUaq0OBCFTxlBYR50B3EnupNZSuLO4k50B/owoIx65qHivfd/m9+G/qWJL03T/UElhPLUqVIhfvNi9rsEkJCEJCQhCfm/yCIiIuXSANlRYhLJjhJTh+wogUEALM0gIiLNWwP7FAQkZ0tyL2ZLnihmG3CiIIMDUI2A7IANLv7zfOxaHo4MksUPs9RomZkVaD25AnAwKwCIlG8P7POQqXPcganDia2euj47qhmtQA/0nwvsg5BqRMzCXrZyaQYPbNIGnCjmPxnYhyAtT2BpKTCcLQUoyICjIAfx2VECgCaPx6/lqcgkIjmAgThKYGAGLA2c2cqlDQ7A0qAXkfrNgX0IAn5fIyAkSY+f6sKJKo94JXVxC1mkg0gJG3CISAMHbCIduAMAWCw10DPp5JtI1MleuFZj67kXHFtPckar4jm405AMiAc6neTfv0iSwYnubqxCriMcEwSKGa0/zVqldHF7k8eWwrUaAe4qiQ1jTgbgZEdF+hNIm3w/J7cBOEp8lXrEUS7SAUDFgCMHpg4Ziql5a2CfhFRDh6NYAeCQara9AJsdNV8DfYZitj0l6eTXkB5HubS9B7CI8yewNK1kh9QATmBpAIrY8d2BfRLiMrNWgxPDpbY9gYIjHHOtSfatVgvj/YF9BHJZnQBgA06gYnAwJEm94/EEYOnJFUnCvWJ1avqF2YtJnMi+iXQ91K0HCg7iJVef6OFreSDy4yRXpBequlAHmVRljGK29LIXqax+ySA6zbqI8Mhj1tCaRMqlGXxmFjt0YL7Vbw7sg5CKpGwl0HocFcfYJwEu0XaUSwPAMOnkl9JFrJm1nnbcEZ2M2QaoyUxJLtxNJJbVHtBm6Y5qbCnRu9iLaHzO+udUVt9HbICQ8+RE97NnXpDBSb6JCGXfaksildU3EVxu/V7MAE6z4hoQCE4FMoFitsFJGgm4iUQ704vq5LjXsqu6IEltpGpOTpv8esVHqnbDqb/pqIv70a1Om3xfJ3f9acgRvdm3euqcqMkMs9QAMmy1ThBxfG9gH4LgKyWoXOZ6qQvVGjEnXxklneTbpn0DZ8hJRKh+MgvOk5PMrNWIHtjqScj83YF9CnKpC+jNLZYf8UPvf9BU4i4n47FreSzyVYyoJQRtP1F9IuEKGxxiIzUVIy8gSzNQtmq29DjKir1nDtjenzqfdQLAQNlTMXIfqRj6o1gxdaAWfmarZqCH4YxWU3MrzLfUfnq14vsx1RL1REzNp4ljyskguo8sTetPsy4NwHyzDDjNItI5dZCd2UrYABxp4PAeEtv+OLV1GmdmYVZE70KNT1j6M53km0jcZHV/QhwxdKfhd8PJnwBs+HKeH7uWxyLXmFbcyFjxxdHZOJ8Fs1akR5JwLyGDqJ9M5sVsQy9UrZFjEaHsxSTCyyd6+FoeiFzpgj8PLa9k/N2thnb8Urp4wU8mydkGJ3sxo/Wxnv5luCX1+G4jl7oACmoynmMhrRYGv/qpqjzSJr9g2n85Q6hGuGvuQi2M+LTqda4fu5aHIzppMXXQ+WQx+ybSQaSsRkCKFZMI8+Rd3EP0JIdYVkfthmi/kSusWp2kTzr5LpL/+pXHX0vdkvk/1fB3yP6tCPjMABgIbHZ+W2CfhPzMyeoZw5Ja8embc1qq5GC68d1FfqiLGbjmk7Xx5676z6z6AHt6xOweIulFTwlJSEIS8hjkP/RTQ2fqLLt6AAAAAElFTkSuQmCC"} style={{ width: '25vh' }} alt="QR Code PIX" />
            <S.IconDone icon='ic:sharp-done-outline' color={theme.theme.colors.positive} height='50px' />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 10 }}>
            <span style={{ fontWeight: 700, fontSize: 16 }}>{props.PagamentoPix}</span>
          </div>

          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 700 }}>Valor da transferência</span>
            <span>{formatToBRL(props.valorTotal)}</span>
          </div>

          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
            <ModalClose asChild>
              <Button full size='md' onClick={handleFechar} variant='primary' >Fechar</Button>
            </ModalClose>
          </div>

        </S.SetpTwoContainer>
      </motion.div >
    )
  }

  return (
    <S.Container>
      <AnimatePresence>
        {step === 1 && <StepOne />}
        {step === 2 && props.PagamentoPix == undefined && <StepTwo handleBack={handleStep(1)} />}
        {step === 3 && props.PixResponse && props.PagamentoPix != undefined && <StepTree />}
      </AnimatePresence>
    </S.Container >
  );
}

export default connector(PagamentoPix);